import React from "react";
import { motion } from "framer-motion";

interface Testimonial {
  text: string;
  image: string;
  name?: string;
  role?: string;
}

export const TestimonialsColumn = (props: {
  className?: string;
  testimonials: Testimonial[];
  duration?: number;
}) => {
  return (
    <div className={props.className}>
      <motion.div
        animate={{ translateY: "-50%" }}
        transition={{
          duration: props.duration || 10,
          repeat: Infinity,
          ease: "linear",
          repeatType: "loop",
        }}
        className="flex flex-col gap-6 pb-6"
      >
        {[...new Array(2).fill(0).map((_, index) => (
          <React.Fragment key={index}>
            {props.testimonials.map(({ text, image, name, role }, i) => (
              <div
                key={`${index}-${i}`}
                className="p-10 rounded-3xl bg-white border border-white/10 shadow-[0_7px_14px_#0c97a9]/10 max-w-xs w-full"
              >
                <div className="text-[#495456] text-sm font-medium leading-relaxed">{text}</div>
                <div className="flex items-center gap-2 mt-5">
                  <img
                    src={image}
                    alt={name || "Utilisateur"}
                    loading="lazy"
                    className="h-10 w-10 rounded-full object-cover"
                  />
                  {(name || role) && (
                    <div className="flex flex-col">
                      {name && (
                        <div className="font-medium tracking-tight leading-5 text-[#074155]">
                          {name}
                        </div>
                      )}
                      {role && (
                        <div className="leading-5 text-[#0C94A6] text-xs tracking-tight">
                          {role}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </React.Fragment>
        ))]}
      </motion.div>
    </div>
  );
};
